import { FC } from "react";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

interface IntegrateCustomMessageHeaderProps {
  collapsed: boolean;
  toggleCollapsed(): void;
  openDialog(): void;
}
export const IntegrationCustomMessageHeader: FC<
  IntegrateCustomMessageHeaderProps
> = ({ collapsed, toggleCollapsed, openDialog }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <IconButton onClick={toggleCollapsed} size="small">
          {!collapsed ? (
            <KeyboardArrowDownOutlinedIcon color="action" />
          ) : (
            <KeyboardArrowUpOutlinedIcon color="action" />
          )}
        </IconButton>

        <Typography variant="body2" fontWeight="medium">
          Message Preview
        </Typography>
      </Stack>
      <Button
        startIcon={<ModeEditOutlineOutlinedIcon fontSize="small" />}
        variant="outlined"
        size="xsmall"
        onClick={openDialog}
      >
        EDIT MESSAGE
      </Button>
    </Stack>
  );
};
